import React from 'react'
import VisuallyHidden from '../../lib/a11y/VisuallyHidden'
import { LABELS } from '../constants/staticText'

// Skeleton-Ladezustand fuer Hub und Abschnittsseite (#111): graue Flaechen in
// der Grundform der Seite statt eines nackten „Lädt …"-Texts. Der Container
// behaelt role="status" und data-state="loading" — darauf warten Screenshot-
// Suite und Tests; der Text bleibt fuer Screenreader erhalten. Die Bloecke
// selbst sind Dekoration (aria-hidden), der Puls liegt hinter
// prefers-reduced-motion (eventsPublic.scss).
const bloecke = (klasse, anzahl) =>
    Array.from({ length: anzahl }, (unused, i) => <span key={i} className={klasse} />)

const FORMEN = {
    // Kachelreihe des Event-Shortcodes: Karten in Breite und Hoehe der echten
    // (.events-card); wie viele je Zeile stehen, regelt das Stylesheet.
    cards: (count) => (
        <span className="event-skeleton-cards events-cards">{bloecke('event-skeleton-card events-card', count)}</span>
    ),
    hub: () => (
        <>
            <span className="event-skeleton-sidebar" />
            <span className="event-skeleton-tiles">{bloecke('event-skeleton-tile', 6)}</span>
        </>
    ),
    section: () => (
        <>
            <span className="event-skeleton-sidebar" />
            <span className="event-skeleton-rows">{bloecke('event-skeleton-row', 4)}</span>
        </>
    )
}

const EventSkeleton = ({ variant, count = 0, label = LABELS.loading }) => (
    <div className="event-skeleton" role="status" data-state="loading" data-variant={variant}>
        <VisuallyHidden>{label}</VisuallyHidden>
        <span className="event-skeleton-shapes" aria-hidden="true">{FORMEN[variant](count)}</span>
    </div>
)

export default EventSkeleton
